<template>
    <!-- Header -->
    <div class="header d-flex align-items-center" :class="{ 'header-on-pos': isPosPage }">

    <!-- Logo -->
    <div class="header-left active">
        <router-link to="/" class="logo logo-normal">
            <img src="/assets/img/otobonik-logo.png" alt="">
        </router-link>
        <router-link to="/" class="logo logo-white">
            <img src="/assets/img/otobonik-logo.png" alt="">
        </router-link>
        <router-link to="/" class="logo-small">
            <img src="/assets/img/otobonik-small.png" alt="">
        </router-link>
        <a id="toggle_btn" href="javascript:void(0);">
            <i class="ti ti-chevrons-left" style="font-size:16px;"></i>
        </a>
    </div>
    <!-- /Logo -->

    <a
      v-if="!isPosPage"
      id="mobile_btn"
      class="mobile_btn"
      href="#sidebar"
    >
        <span class="bar-icon">
            <span></span>
            <span></span>
            <span></span>
        </span>
    </a>

    <!-- Tenant branding (from invoice settings); blank when none -->
    <div class="header-tenant-brand" v-if="tenantLogo || companyName">
      <img v-if="tenantLogo" :src="tenantLogo" alt="Business logo" class="header-tenant-logo-img">
      <span v-if="companyName" class="header-company-name">{{ companyName }}</span>
    </div>

    <!-- Header Menu -->
    <div class="header-right ms-auto">
      <ul class="nav user-menu">

        <!-- Search -->
<!--        <li class="nav-item nav-searchinputs">-->
<!--            <div class="top-nav-search">-->
<!--                <a href="javascript:void(0);" class="responsive-search">-->
<!--                    <i class="fa fa-search"></i>-->
<!--                </a>-->
<!--                <form action="#" class="dropdown">-->
<!--                    <div class="searchinputs dropdown-toggle" id="dropdownMenuClickable"-->
<!--                        data-bs-toggle="dropdown" data-bs-auto-close="false">-->
<!--                        <input type="text" placeholder="Search">-->
<!--                        <div class="search-addon">-->
<!--                            <span><i data-feather="x-circle" class="feather-14"></i></span>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="dropdown-menu search-dropdown" aria-labelledby="dropdownMenuClickable">-->
<!--                        <div class="search-info">-->
<!--                            <h6><span><i data-feather="search" class="feather-16"></i></span>Recent Searches-->
<!--                            </h6>-->
<!--                            <ul class="search-tags">-->
<!--                                <li><a href="javascript:void(0);">Products</a></li>-->
<!--                                <li><a href="javascript:void(0);">Sales</a></li>-->
<!--                                <li><a href="javascript:void(0);">Applications</a></li>-->
<!--                            </ul>-->
<!--                        </div>-->
<!--                        <div class="search-info">-->
<!--                            <h6><span><i data-feather="help-circle" class="feather-16"></i></span>Help</h6>-->
<!--                            <p>How to Change Product Volume from 0 to 200 on Inventory management</p>-->
<!--                            <p>Change Product Name</p>-->
<!--                        </div>-->
<!--                        <div class="search-info">-->
<!--                            <h6><span><i data-feather="user" class="feather-16"></i></span>Customers</h6>-->
<!--                            <ul class="customers">-->
<!--                                <li>-->
<!--                                    <a href="javascript:void(0);">Aron Varu<img src="/assets/img/profiles/avator1.jpg" alt="" class="img-fluid"></a>-->
<!--                                </li>-->
<!--                                <li>-->
<!--                                    <a href="javascript:void(0);">Jonita<img src="/assets/img/profiles/avatar-01.jpg" alt="" class="img-fluid"></a>-->
<!--                                </li>-->
<!--                                <li>-->
<!--                                    <a href="javascript:void(0);">Aaron<img src="/assets/img/profiles/avatar-10.jpg" alt="" class="img-fluid"></a>-->
<!--                                </li>-->
<!--                            </ul>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </form>-->
<!--            </div>-->
<!--        </li>-->
        <!-- /Search -->

        <li class="nav-item pos-nav">
          <router-link v-if="isPosPage" to="/" class="btn btn-dark btn-md d-inline-flex align-items-center" title="Dashboard">
            <i class="ti ti-dashboard"></i><span class="pos-nav-label ms-1">Dashboard</span>
          </router-link>

          <router-link v-else  to="/pos" class="btn btn-dark btn-md d-inline-flex align-items-center" title="POS">
            <i class="ti ti-device-laptop"></i><span class="pos-nav-label ms-1">POS</span>
          </router-link>
        </li>

        <!-- Select Store -->
        <li class="nav-item dropdown has-arrow main-drop select-store-dropdown">
          <a
            href="javascript:void(0);"
            class="dropdown-toggle nav-link select-store"
            data-bs-toggle="dropdown"
          >
            <span class="user-info">
              <span class="user-detail">
                <!-- Hidden (but keeps its space) until stores load, so the placeholder never flashes -->
                <span class="user-name" :style="{ visibility: storesLoaded ? 'visible' : 'hidden' }">{{ selectedStoreName }}</span>
              </span>
            </span>
          </a>
          <div class="dropdown-menu dropdown-menu-right">
            <a
              v-for="store in stores"
              :key="store.id"
              href="javascript:void(0);"
              class="dropdown-item"
              :class="{ active: String(store.id) === String(selectedStoreId) }"
              @click.prevent="onStoreChange(store.id)"
            >
              <span class="store-option-label">{{ store.name }}</span>
              <svg
                v-if="String(store.id) === String(selectedStoreId)"
                class="store-option-check"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <path d="M5 12l5 5l10 -10" />
              </svg>
            </a>
          </div>
        </li>
        <!-- /Select Store -->

        <!-- Calculator (POS) -->
        <li v-if="isPosPage" class="nav-item nav-item-box">
          <a
            href="javascript:void(0);"
            data-bs-toggle="modal"
            data-bs-target="#calculator"
            class="bg-orange border-orange text-white pos-calculator-btn"
            title="Calculator"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M19 2H5C3.897 2 3 2.897 3 4V20C3 21.103 3.897 22 5 22H19C20.103 22 21 21.103 21 20V4C21 2.897 20.103 2 19 2ZM5 20V4H19L19.001 20H5Z"></path>
              <path d="M7 12H9V14H7V12ZM7 16H9V18H7V16ZM11 12H13V14H11V12ZM7 6H17V10H7V6ZM11 16H13V18H11V16ZM15 12H17V18H15V12Z"></path>
            </svg>
          </a>
        </li>
        <!-- /Calculator -->

        <!-- Language Switcher -->
        <li class="nav-item dropdown has-arrow flag-nav nav-item-box">
          <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" role="button">
            <img :src="currentFlag" :alt="currentLanguage" class="img-fluid">
          </a>
          <div class="dropdown-menu dropdown-menu-right">
            <a
              v-for="(lang, code) in languages"
              :key="code"
              href="#"
              class="dropdown-item"
              :class="{ active: currentLanguage === lang.name }"
              @click.prevent="changeLanguage(code)"
            >
              <img :src="lang.flag" :alt="lang.name" height="16"> {{ lang.name }}
            </a>
          </div>
        </li>
        <!-- /Language Switcher -->

<!--        <li class="nav-item nav-item-box">-->
<!--            <a href="javascript:void(0);" id="btnFullscreen">-->
<!--                <i data-feather="maximize"></i>-->
<!--            </a>-->
<!--        </li>-->
<!--        <li class="nav-item nav-item-box">-->
<!--            <a href="email.html">-->
<!--                <i data-feather="mail"></i>-->
<!--                <span class="badge rounded-pill">1</span>-->
<!--            </a>-->
<!--        </li>-->
        <!-- Notifications -->
<!--        <li class="nav-item dropdown nav-item-box">-->
<!--            <a href="javascript:void(0);" class="dropdown-toggle nav-link" data-bs-toggle="dropdown">-->
<!--                <i data-feather="bell"></i><span class="badge rounded-pill">2</span>-->
<!--            </a>-->
<!--            <div class="dropdown-menu notifications">-->
<!--                <div class="topnav-dropdown-header">-->
<!--                    <span class="notification-title">Notifications</span>-->
<!--                    <a href="javascript:void(0)" class="clear-noti"> Clear All </a>-->
<!--                </div>-->
<!--                <div class="noti-content">-->
<!--                    <ul class="notification-list">-->
<!--                        <li class="notification-message">-->
<!--                            <a href="activities.html">-->
<!--                                <div class="media d-flex">-->
<!--                                    <span class="avatar flex-shrink-0">-->
<!--                                        <img alt="" src="/assets/img/profiles/avatar-02.jpg">-->
<!--                                    </span>-->
<!--                                    <div class="media-body flex-grow-1">-->
<!--                                        <p class="noti-details"><span class="noti-title">John Doe</span> added-->
<!--                                            new task <span class="noti-title">Patient appointment booking</span>-->
<!--                                        </p>-->
<!--                                        <p class="noti-time"><span class="notification-time">4 mins ago</span>-->
<!--                                        </p>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </a>-->
<!--                        </li>-->
<!--                        <li class="notification-message">-->
<!--                            <a href="activities.html">-->
<!--                                <div class="media d-flex">-->
<!--                                    <span class="avatar flex-shrink-0">-->
<!--                                        <img alt="" src="/assets/img/profiles/avatar-03.jpg">-->
<!--                                    </span>-->
<!--                                    <div class="media-body flex-grow-1">-->
<!--                                        <p class="noti-details"><span class="noti-title">Tarah Shropshire</span>-->
<!--                                            changed the task name <span class="noti-title">Appointment booking-->
<!--                                            with payment gateway</span>-->
<!--                                        </p>-->
<!--                                        <p class="noti-time"><span class="notification-time">6 mins ago</span>-->
<!--                                        </p>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </a>-->
<!--                        </li>-->
<!--                        <li class="notification-message">-->
<!--                            <a href="activities.html">-->
<!--                                <div class="media d-flex">-->
<!--                                    <span class="avatar flex-shrink-0">-->
<!--                                        <img alt="" src="/assets/img/profiles/avatar-06.jpg">-->
<!--                                    </span>-->
<!--                                    <div class="media-body flex-grow-1">-->
<!--                                        <p class="noti-details"><span class="noti-title">Misty Tison</span>-->
<!--                                            added <span class="noti-title">Domenic Houston</span> and <span-->
<!--                                            class="noti-title">Claire Mapes</span> to project <span-->
<!--                                            class="noti-title">Doctor available module</span>-->
<!--                                        </p>-->
<!--                                        <p class="noti-time"><span class="notification-time">8 mins ago</span>-->
<!--                                        </p>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </a>-->
<!--                        </li>-->
<!--                        <li class="notification-message">-->
<!--                            <a href="activities.html">-->
<!--                                <div class="media d-flex">-->
<!--                                    <span class="avatar flex-shrink-0">-->
<!--                                        <img alt="" src="/assets/img/profiles/avatar-17.jpg">-->
<!--                                    </span>-->
<!--                                    <div class="media-body flex-grow-1">-->
<!--                                        <p class="noti-details"><span class="noti-title">Rolland Webber</span>-->
<!--                                            completed task <span class="noti-title">Patient and Doctor video conferencing</span>-->
<!--                                        </p>-->
<!--                                        <p class="noti-time"><span class="notification-time">12 mins ago</span></p>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </a>-->
<!--                        </li>-->
<!--                        <li class="notification-message">-->
<!--                            <a href="activities.html">-->
<!--                                <div class="media d-flex">-->
<!--                                    <span class="avatar flex-shrink-0">-->
<!--                                        <img alt="" src="/assets/img/profiles/avatar-13.jpg">-->
<!--                                    </span>-->
<!--                                    <div class="media-body flex-grow-1">-->
<!--                                        <p class="noti-details"><span class="noti-title">Bernardo Galaviz</span>-->
<!--                                            added new task <span class="noti-title">Private chat module</span>-->
<!--                                        </p>-->
<!--                                        <p class="noti-time"><span class="notification-time">2 days ago</span></p>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </a>-->
<!--                        </li>-->
<!--                    </ul>-->
<!--                </div>-->
<!--                <div class="topnav-dropdown-footer">-->
<!--                    <a href="activities.html">View all Notifications</a>-->
<!--                </div>-->
<!--            </div>-->
<!--        </li>-->
        <!-- /Notifications -->

<!--        <li class="nav-item nav-item-box">-->
<!--            <a href="general-settings.html"><i data-feather="settings"></i></a>-->
<!--        </li>-->

        <li class="nav-item dropdown has-arrow main-drop">
            <a href="javascript:void(0);" class="dropdown-toggle nav-link userset" data-bs-toggle="dropdown">
                <span class="user-info">
                    <span class="user-letter">
                        <img src="/assets/img/profiles/default-user.jpeg" alt="" class="img-fluid">
                    </span>
                    <span class="user-detail">
                        <span class="user-name">{{ username }}</span>
                        <span class="user-role">{{ role }}</span>
                    </span>
                </span>
            </a>
            <div class="dropdown-menu menu-drop-user">
                <div class="profilename">
                    <div class="profileset">
                        <span class="user-img"><img src="/assets/img/profiles/default-user.jpeg" alt="">
                            <span class="status online"></span></span>
                        <div class="profilesets">
                            <h6>{{ user?.username }}</h6>
                            <h5>{{ user?.role }}</h5>
                        </div>
                    </div>
                    <hr class="m-0">
<!--                    <a class="dropdown-item" href="profile.html"> <i class="me-2" data-feather="user"></i> My Profile</a>-->
<!--                    <a class="dropdown-item" href="general-settings.html"><i class="me-2" data-feather="settings"></i>Settings</a>-->

                    <!-- Change Password -->
                    <router-link class="dropdown-item" to="/change/password/">
                      <i class="ti ti-lock me-2"></i>
                      Change Password
                    </router-link>

                    <hr class="m-0">
                    <a class="dropdown-item logout pb-0" href="#" @click.prevent="logout"><img src="/assets/img/icons/log-out.svg" class="me-2" alt="img">Logout</a>
                </div>
            </div>
        </li>
    </ul>
    </div>
    <!-- /Header Menu -->
  </div>
  <!-- /Header -->
</template>

<script>
  import apiUrls from "@/urls";
  import { clearPermissions } from "@/helpers/permission";

  export default {
    name: "Header",

    data() {
      return {
        user: null,
        currentLanguage: "English",
        currentFlag: "/assets/img/flags/us.png",
        languages: {
          en: { name: "English", flag: "/assets/img/flags/us.png" },
          bn: { name: "Bangla", flag: "/assets/img/flags/bd.png" },
        },
        selectedStoreId: null,
        stores: [],
        storesLoaded: false,
        tenantLogo: null,
        companyName: null,
      };
    },

    computed: {
      username() {
        return this.user?.username || "Guest";
      },

      role() {
        return this.user?.role || "";
      },

      selectedStore() {
        return this.stores.find(
          (store) => String(store.id) === String(this.selectedStoreId)
        ) || null;
      },

      selectedStoreName() {
        return this.selectedStore?.name || this.$t("select_store");
      },

      isPosPage() {
        return this.$route.path.startsWith("/pos");
      }
    },

    async created() {
      try {
        // Fetch user, stores, and tenant logo together
        const [, res] = await Promise.all([
          localStorage.getItem("auth_token") ? this.fetchUser() : null,
          this.$axios.get(apiUrls.stores.get),
          this.fetchTenantLogo(),
        ]);
        this.stores = res.data;

        // The store list is already limited to the stores this user may use (staff: all,
        // others: only their assigned one), so a saved pick from that list is trusted.
        const savedStoreId = localStorage.getItem("store_id");
        const savedStore = this.stores.find(s => String(s.id) === String(savedStoreId));
        const assignedStore = this.stores.find(s => String(s.id) === String(this.user?.store));

        if (savedStore) {
          this.selectedStoreId = savedStore.id;
        } else if (assignedStore) {
          this.selectedStoreId = assignedStore.id;
        } else if (this.stores.length > 0) {
          this.selectedStoreId = this.stores[0].id;
        }

        if (this.selectedStoreId) {
          localStorage.setItem("store_id", this.selectedStoreId);
          // The page already loaded its data without a store; load it again with one.
          if (!savedStore) window.location.reload();
        }

      } catch (err) {
        if (err.response?.status === 401) {
          this.logout();
        } else if (err.response?.status === 403 && localStorage.getItem("store_id")) {
          // Saved store is not this user's (another login on this browser, or it was
          // deleted): every call is refused while it is sent. Drop it and start clean.
          localStorage.removeItem("store_id");
          window.location.reload();
        } else {
          console.error("Header init error:", err);
        }
      } finally {
        this.storesLoaded = true;
      }
    },

    methods: {
      async fetchUser() {
        try {
          const res = await this.$axios.get(apiUrls.login_user.get);
          this.user = res.data
        } catch (e) {
          console.error('User fetch failed', e)
        }
      },

      async fetchTenantLogo() {
        if (!localStorage.getItem("auth_token")) {
          this.tenantLogo = null;
          this.companyName = null;
          return;
        }
        try {
          const { data } = await this.$axios.get(apiUrls.invoice_setting.get);
          const row = Array.isArray(data) ? data[0] : null;
          this.tenantLogo = row?.logo || null;
          this.companyName = (row?.business_name || "").trim() || null;
        } catch (e) {
          this.tenantLogo = null;
          this.companyName = null;
        }
      },

      clearMobileMenuOverlay() {
        document.documentElement.classList.remove("menu-opened");
        document.querySelectorAll(".main-wrapper.slide-nav").forEach((el) => {
          el.classList.remove("slide-nav");
        });
        document.querySelectorAll(".sidebar-overlay.opened").forEach((el) => {
          el.classList.remove("opened");
        });
      },

      async logout() {
          if (localStorage.getItem("auth_token")) {
            try {
              await this.$axios.post(apiUrls.user.logout);
            } catch (e) {
              // Token already invalid; clearing it locally is enough.
            }
          }
          localStorage.removeItem("auth_token");
          localStorage.removeItem("store_id");
          clearPermissions();
          this.$router.push("/login");
      },

      async changeLanguage(code) {
        this.currentLanguage = this.languages[code].name;
        this.currentFlag = this.languages[code].flag;

        try {
          // Call Django API to update the language
          await this.$axios.post("user/switch-language/", { language: code });

          // Save selected language in localStorage
          localStorage.setItem("selectedLanguage", code);
          localStorage.setItem("selectedFlag", this.languages[code].flag);

          // Dynamically change the language in the Vue I18n instance
          this.$i18n.locale = code;

        } catch (error) {
          console.error("Error switching language:", error);
        }
      },

      onStoreChange(storeId) {
        if (!storeId) return;
        if (String(storeId) === String(this.selectedStoreId)) return;

        localStorage.setItem("store_id", storeId);
        window.location.reload();
      },
    },

    mounted() {
      const savedLang = localStorage.getItem("selectedLanguage") || "en";

      if (localStorage.getItem("auth_token")) {
        this.changeLanguage(savedLang);
      } else {
        this.$i18n.locale = savedLang;
        this.currentLanguage = this.languages[savedLang].name;
        this.currentFlag = this.languages[savedLang].flag;
      }

      // Always clear: after POS ↔ main layout swaps the overlay can stay open on a
      // detached wrapper, leaving only the black screen for the next menu tap.
      this.clearMobileMenuOverlay();
    },

    watch: {
      isPosPage() {
        this.clearMobileMenuOverlay();
      },
      "$route.fullPath"() {
        this.clearMobileMenuOverlay();
      },
    },

  };
</script>

<style scoped>
.header-tenant-brand {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  flex: 0 0 auto;
  min-width: 0;
  padding: 0 16px 0 28px;
  overflow: hidden;
}

.header-tenant-logo-img {
  max-height: 42px;
  max-width: 160px;
  width: auto;
  height: auto;
  object-fit: contain;
  flex-shrink: 0;
}

.header-company-name {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #1B2559;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 280px;
  line-height: 1.25;
}

.pos-calculator-btn {
  background-color: #FE9F43 !important;
  border: 1px solid #FE9F43 !important;
  color: #ffffff !important;
}

.pos-calculator-btn:hover {
  background-color: #e8892d !important;
  border-color: #e8892d !important;
  color: #ffffff !important;
}

.pos-calculator-btn svg {
  display: block;
  color: #ffffff;
  fill: currentColor;
}

/* Theme select-store, text-only (no logo) */
.select-store-dropdown :deep(.select-store .user-info) {
  padding: 0 20px 0 4px;
}

.select-store-dropdown :deep(.select-store .user-info .user-detail) {
  display: block !important;
}

.select-store-dropdown :deep(.select-store .user-info .user-name) {
  font-size: 14px;
  font-weight: 400;
  color: #212B36 !important;
}

.select-store-dropdown :deep(.dropdown-menu) {
  padding: 8px;
  min-width: 200px;
}

.select-store-dropdown :deep(.dropdown-item) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 9px 16px;
  color: #212B36 !important;
  background: transparent !important;
  border-radius: 5px;
  font-weight: 500;
  transition: none;
}

.select-store-dropdown :deep(.dropdown-item .store-option-label) {
  flex: 1;
  min-width: 0;
}

.select-store-dropdown :deep(.dropdown-item .store-option-check) {
  flex-shrink: 0;
  color: #FE9F43;
}

/* Theme-style hover */
.select-store-dropdown :deep(.dropdown-item:hover),
.select-store-dropdown :deep(.dropdown-item:focus) {
  background: #FFF6EE !important;
  color: #FE9F43 !important;
}

/* Selected = checkmark + darker text (different from hover) */
.select-store-dropdown :deep(.dropdown-item.active),
.select-store-dropdown :deep(.dropdown-item:active) {
  background: transparent !important;
  color: #212B36 !important;
  font-weight: 600;
}

/* Selected + hover still uses theme hover, check stays */
.select-store-dropdown :deep(.dropdown-item.active:hover),
.select-store-dropdown :deep(.dropdown-item.active:focus) {
  background: #FFF6EE !important;
  color: #FE9F43 !important;
}

/* Company name: web only */
@media (max-width: 991.98px) {
  .header-company-name {
    display: none;
  }
}

/* The theme centres the logo across the whole bar on small screens and hides the menu; the menu stays,
   so the logo sits beside the sidebar button instead of under the icons. */
@media (max-width: 991.98px) {
  .header .header-left {
    position: static;
    width: auto;
    flex-shrink: 0;
    padding: 0 8px 0 60px;
  }

  /* POS has no sidebar / hamburger — drop the space reserved for mobile_btn */
  .header.header-on-pos .header-left {
    padding-left: 12px;
  }

  .header .header-left .logo {
    width: auto;
  }

  .header .header-left .logo img {
    width: 110px;
  }

  .header-tenant-brand {
    padding: 0 8px 0 16px;
    justify-content: flex-start;
  }

  .header-tenant-logo-img {
    max-height: 32px;
    max-width: 120px;
  }

  .header .header-right {
    min-width: 0;
  }

  .header .user-menu {
    flex-wrap: nowrap;
    justify-content: flex-end;
    padding-right: 12px;
  }

  .header .user-menu > li {
    margin-left: 8px;
  }
}

@media (max-width: 575.98px) {
  .header .header-left {
    padding-right: 4px;
  }

  .header .header-left .logo-normal {
    display: none;
  }

  .header .header-left .logo-small {
    display: inline-block;
    line-height: 0;
  }

  .header .header-left .logo-small img {
    width: 30px;
  }

  .header-tenant-brand {
    padding: 0 4px 0 12px;
  }

  .header-tenant-logo-img {
    max-height: 28px;
    max-width: 80px;
  }

  .pos-nav-label {
    display: none;
  }

  .header .user-menu > li.pos-nav {
    padding-right: 6px;
  }

  .header .user-menu > li.pos-nav .btn {
    padding: 6px 9px;
  }

  .header .user-menu {
    padding-right: 8px;
  }

  .header .user-menu > li {
    margin-left: 6px;
    flex-shrink: 0;
  }

  /* the store name gives way first when the bar is tight */
  .header .user-menu > li.select-store-dropdown {
    flex-shrink: 1;
    min-width: 0;
  }

  .select-store-dropdown .select-store {
    display: block;
    min-width: 0;
  }

  .select-store-dropdown .select-store .user-name {
    display: block;
    max-width: 90px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /* avatar only: the name is already hidden by the theme, so drop its arrow too */
  .header .userset .user-info {
    padding-right: 0;
  }

  .header .userset .user-info::after {
    display: none;
  }
}
</style>

